import axios from 'axios'
export default {
  state: {
    results: [],
  },
  getters: {
    searchResults: (s) => s.results,
  },
  mutations: {
    updateSearchResults(s, { results, q }) {
      let reg = new RegExp(q, 'gi')
      results.forEach(function (el) {
        el.title =
          el.title
            ?.replaceAll(reg, (str) => `<strong>${str}</strong>`)
            .replace(/[<]br[^>]*[>]/gi, ' ') ||
          el.name
            ?.replaceAll(reg, (str) => `<strong>${str}</strong>`)
            .replace(/[<]br[^>]*[>]/gi, ' ')
      })
      s.results = results
    },
  },
  actions: {
    async fetchSearch(ctx, { q: q, lang = 'ru' }) {
      // if (lang === 'be') lang = 'ru';
      return axios({
        method: 'GET',
        url: `/api/v3/search?query=${q}&language=${lang}`,
      })
        .then((response) => {
          const status = response.data.status
          if (status >= 400) {
            return false
          }
          ctx.commit('updateSearchResults', {
            results: response.data.filter((el) => el.type !== 'webinar'),
            q: q,
          })
          return true
        })
        .catch((error) => {
          console.error(error)
          return false
        })
    },
    clearSearch(ctx) {
      ctx.commit('updateSearchResults', { results: [], q: '' })
    },
  },
}
